import {
  Component,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  ViewChild,
  OnInit,
  AfterViewInit
} from "@angular/core";
import { Observable } from "rxjs";
import { Validacao } from "./validacao";
import { ValidacaoService } from "./validacao.service";
import { Estudo } from "../estudo/estudo";
import { EstudoService } from "../estudo/estudo.service";
import { SituacaoEnum } from "../util/situacao.enum";
import { Router, ActivatedRoute } from "@angular/router";
import { MatSnackBar, MatPaginator, MatSort, MatTableDataSource, PageEvent } from "@angular/material";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { ValidacaoDialog } from "./validacao.dialog";
import { ConfirmacaoDialog } from "../util/confirmacao.dialog";
import { Confirmacao } from "../util/confirmacao";

@Component({
  templateUrl: "./validacao-list.component.html",
  selector: "validacao-list",
  styleUrls: [ './validacao-list.component.css' ]
})
export class ValidacaoListComponent implements OnInit {
  @Input() podeEditar: boolean;
  @Input() estudo: Estudo;
  @Input() atualizar: boolean;
  @Output()  listaAtualizada: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() estudoEmitido: EventEmitter<Estudo> = new EventEmitter<Estudo>();

  public lista: Validacao[];
  public isLoading: boolean;
  public filtro: string;
  public ordenar: string;

  // datatable variables
  public columnsToDisplay = [
    'perguntaEnunciado',
    'perguntaIdentificacao',
    'descricao',
    'corrigido',
    `acao`   
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  public dataSource = new MatTableDataSource<Validacao>(this.lista);

  // MatPaginator Output
  pageEvent: PageEvent;

  // construtor
  constructor(
    private validacaoService: ValidacaoService,
    private router: Router,
    private route: ActivatedRoute,
    public  mensagem: MatSnackBar,
    public dialog: MatDialog,
    private estudoService: EstudoService
  ) {}

  // ngOnInit é executado ao entrar na tela
  public ngOnInit() {
    this.filtro = this.route.snapshot.params["filtro"];
    this.dataSource.paginator = this.paginator;
    this.buscar();
  }


  // busca com filtro
  private buscar() {
    this.isLoading = true;
    let validacao: Validacao = new Validacao();
    validacao.codigoEstudoSocioEconomico = this.estudo.id;
    this.validacaoService.filtrarCompleto(validacao, this.ordenar).subscribe(
      (results: Validacao[]) => {
        this.lista = results;
        this.dataSource = new MatTableDataSource<Validacao>(results);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.isLoading = false;
        this.listaAtualizada.emit(true);
      },
      error => this.erro(error)
    );
  }

  public filtrarDinamico(filterValue: string): void {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  public sortData(sort: any) {
    if (!sort.active || sort.direction === '') {
      return;
    } else {
      this.ordenar = sort.active + ' ' + sort.direction ;
      this.buscar();
    }
  }


  public corrigido(validacao: Validacao) {
    // agora estou permitindo alterar as validações inválidas
    let podeEditar = this.podeEditar;
    if (validacao.validacaoValida == false && validacao.corrigido == false) {
      podeEditar = true;
    }

    if (!podeEditar) {
      this.mostrarMensagemEdicaoNaoPermitida();
    } else {
      //soh altero o Status
      if (validacao.corrigido == true) {
        validacao.corrigido = false;
      } else {
        validacao.corrigido = true;
      }
      this.salvar(validacao);
    }
  }

  private salvar(validacao: Validacao) {
    this.validacaoService.update(validacao).subscribe(
      result => {
        // atualizo o estudo
        //this.carregaEstudo();
        this.mensagem.open("Registro salvo com sucesso!", "X", {
          duration: 5000
        });
        this.buscar();
      },
      error => this.erro(error)
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      let chng = changes[propName];
      // se for a primeira vez q entrou..
      if (propName == "atualizar") {
        if (chng.currentValue) {
          this.buscar();
        }
      }
    }
  }

  public excluir(validacao: Validacao) {
    // agora estou permitindo alterar as validações inválidas
    let podeEditar = this.podeEditar;
    if (validacao.validacaoValida == false && validacao.corrigido == false) {
      podeEditar = true;
    }

    if (!podeEditar) {
      this.mostrarMensagemEdicaoNaoPermitida();
    } else {
      let confirmacao: Confirmacao = new Confirmacao(
        "Deseja excluir o registro: " + validacao.descricao,
        false
      );
      let dialogRef = this.dialog.open(ConfirmacaoDialog, {
        width: "400px",
        data: confirmacao
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.deletar(validacao);
        }
      });

      this.buscar();
    }
  }

  private deletar(validacao: Validacao) {
    this.isLoading = true;
    this.validacaoService.deletar(validacao).subscribe(
      result => {
        this.mensagem.open("Registro excluído com sucesso!", "X", {
          duration: 5000
        });
        // recarrega a lista
        this.buscar();
      },
      error => this.erro(error)
    );
  }

  public editar(validacao: Validacao) {
    if (!this.podeEditar) {
      this.mostrarMensagemEdicaoNaoPermitida();
    } else {
      this.abrirDialog(validacao);
    }
  }

  private abrirDialog(validacao: Validacao) {
    let dialogRef = this.dialog.open(ValidacaoDialog, {
      width: "400px",
      data: validacao
    });
    let resultado: any;
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.salvar(validacao);
      }
    });
  }

  // criei esse método, pq o angular estava com um bug q não permitia esconder os botões de edição, excluir e altarar Status
  // quando atualizar a versão do angular, tentar novamente esconder esses botões
  mostrarMensagemEdicaoNaoPermitida() {
    this.mensagem.open(
      "A validação só pode ser feita em estudos cujo status seja: 'Em Análise' ou 'Corrigido' ou em casos de validações inconsistentes.",
      "X",
      { duration: 9000 }
    );
  }

  public pontuar() {
    this.router.navigate(["/pontuacao", this.estudo.id]);
  }

  // quando um membro eh excuido da lista, eu tenho q atualizar minhas validacoes
  public membroExcluidoEmitido(event: number) {
    this.buscar();
  }

  public voltarParaEmAnalise(){
    let confirmacao: Confirmacao = new Confirmacao(
      "Deseja voltar a situação do estudo para 'Em Análise'?",  false
    );
    let dialogRef = this.dialog.open(ConfirmacaoDialog, {
      width: "400px",
      data: confirmacao
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.alteraHomologadoParaAnalise();
      }
    });
  }

  private alteraHomologadoParaAnalise(){
    this.estudo.situacao = SituacaoEnum.EmAnalise;
    this.estudoService.update(this.estudo).subscribe((result: Estudo) =>{
      this.estudo = result;
      this.estudoEmitido.emit(this.estudo);
      this.mensagem.open( "Situação do estudo alterado de 'Homologado' para 'Em Análise'.", "X", { duration: 9000} );
      },
    error => this.erro(error)
    );
  }

  voltar() {
    this.router.navigate(["/estudolist", { filtro: this.filtro }]);
  }

  // mostra erros na tela
  private erro(erro: string) {
    this.mensagem.open(erro, "X", { duration: 5000 });
    this.isLoading = false;
  }
}
